import {FC, ReactElement} from 'react';
import Text from '@atoms/Text';
import {EmptyBlockContentWrapper, EmptyBlockWrapper} from '@molecules/EmptyBlock.styles';
import IconWithBackground from '@atoms/IconWithBackground';

export interface EmptyBlockProps {
  icon: ReactElement;
  text?: string;
}

const EmptyBlock: FC<EmptyBlockProps> = ({icon, text}) => {
  return (
    <EmptyBlockWrapper>
      <EmptyBlockContentWrapper>
        <IconWithBackground icon={icon} />
        {text && <Text text={text} align="center" />}
      </EmptyBlockContentWrapper>
    </EmptyBlockWrapper>
  );
};

export default EmptyBlock;
